import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/product/productContext'
import CustomCommonContext from '@/product/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'
import Loaders from '@/product/components/molecules/Loaders'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import AsinContext from '@/product/context/thirdParty/asin/asinContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CatalogView from './CatalogView'
import './Product.css'
const CatalogSearch = (props) => {
    const { bulkProjectAction } = useContext(ProductContext)
    const [isLoading, setIsLoading] = useState(false)
    const { resetDropZone } = useContext(ProductCommonContext)
    const [reload, setReload] = useState(false)
    const asinContext = useContext(AsinContext)
    const { getCatalog, catalog_products } = asinContext
    const { allCategory, allLocations, allCondition } =
        useContext(CustomCommonContext)

    const [tableBody, setTableBody] = useState([])

    const { getAllUsers, all_users } = useContext(UserContext)

    const data = props.data
    const toggleCatalogPopup = props.function

    const validationArray = Yup.object({
        title: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            title: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            getCatalog(values)
        },
    })

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Search',
                placeholder: 'Search title keyword here',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'title',
            },
        ],
    }

    useEffect(() => {
        console.log(catalog_products, 'catalog_prof')
        if (catalog_products && catalog_products.record.length) {
            setTableBody(catalog_products.record)
            setIsLoading(false)
        } else {
            setTableBody([])
            setIsLoading(false)
        }
    }, [catalog_products])

    const closeFunction = () => {
        toggleCatalogPopup(false)
        setTableBody([])
    }

    return (
        <FullScreenPopup
            modaltitle={`Catalog Search`}
            open={data.popup}
            handleClose={() => closeFunction()}
        >
            <div className="addUserModal">
                <div className="dashboard listing">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {tableBody.length
                                ? // <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 mb-4">
                                  tableBody.map((data) => (
                                      <CatalogView data={data} />
                                  ))
                                : // </div>
                                  null}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default CatalogSearch
